import "./buttons.scss";

import PlusIcon from "@/common/images/icons/plusIcon.svg?react";

export const PlusButton = (props: {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  hint?: string;
}) => {
  return (
    <button className="plus rg-button rg-red" onClick={props.onClick} title={props.hint} aria-label={props.hint}>
      <PlusIcon />
    </button>
  );
};
